module.exports = __webpack_public_path__ + "img/special_2.10a8d6b6.png";